import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import AppStore from "../../config/AppStore";
import { sendRequestGetAdvertiserOffers, sendRequestAdvertiserOfferReorderFormSubmitRequest } from "../../view_logics/AdvertiserOffers/AdvertiserOffer";
import dragula from "dragula";
import "dragula/dist/dragula.min.css";

const TableComponent = ({ dataSet, loading }) => {
  const [data, setData] = useState(dataSet);
  const store = AppStore.getAppStoreInstance();
  const navigate = useNavigate();
  const [isReorder, setIsReorder] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    setData(dataSet);
  }, [dataSet]);

  // Initialize drag-and-drop functionality
  useEffect(() => {
    const drake = dragula([containerRef.current]);

    // Handle the drop event to update the order
    drake.on('drop', () => {
      
      const newOrder = Array.from(containerRef.current.children).map((child, index) => {
        // Find the item that corresponds to this child element in the DOM
        const updatedItem = data.find(item => item.offerID === child.dataset.offerid);
        console.log("I am here",child);
        // Update the orderNo based on the new index, but keep the other properties (like name) intact
        return {
          ...updatedItem,
          orderNo: index + 1, // Update the orderNo to reflect the new position
          offerID: child.dataset.offerid,
          name:child.dataset.name
        };
      });

      setData(newOrder); // Update the table with the new order
      setIsReorder(true); // Enable the 'Update Display Order' button
    });

    return () => {
      drake.destroy(); // Clean up on component unmount
    };
  }, [data]);

  const handleUpdateClick = () => {
    const formattedData = data.map((item) => ({
      display_order: item.orderNo, // The order number (updated order)
      offer_id: item.offerID,       // The offer ID
      name: item.name,              // The name (remains unchanged)
    }));

    console.log("Updated Order Data:", formattedData);

    const inputObj = {
      accessToken: store.getState().login.accessToken,
      url: "/reorder-offers",
      history: navigate,
      dataToPost: formattedData,
    };
    sendRequestAdvertiserOfferReorderFormSubmitRequest(inputObj);
    setIsReorder(false);
  };

  return (
    <>
      <button
        type="button"
        disabled={!isReorder}
        style={{ height: 38 }}
        className="btn btn-primary float-right mb-3"
        onClick={handleUpdateClick}
      >
        Update Display Order
      </button>
      <div className="card mb-0 p-2 cursor-grab border border-redius-0">
        <div className="row">
          <div className="col-3"><b>Display Order</b></div>
          <div className="col-3"><b>Offer ID</b></div>
          <div className="col-6"><b>Offer Name</b></div>
        </div>
      </div>
      <div ref={containerRef}>
      
        {data.map((item, index) => (
          <div
            key={item.offerID}
            className="card mb-0 cursor-grab border"
            data-offerid={item.offerID} // Use the offerID as data attribute to reference
            data-name={item.name}
            style={{ backgroundColor: index % 2 === 0 ? "#d2f1e8" : "#ffffff" }}
          >
            <div className="card-body p-2">
              <div className="row">
                <div className="col-1">⋮⋮⋮</div>
                <div className="col-2">{item.orderNo}</div>
                <div className="col-3">{item.offerID}</div>
                <div className="col-6">{item.name}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

function ReorderAdvertiserOffers() {
  const [offerData, setOfferData] = useState([]);
  const [loading, setLoading] = useState(true);
  const store = AppStore.getAppStoreInstance();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        const request = {
          accessToken: store.getState().login.accessToken,
          url: "editAdvertiser",
          history: navigate,
          dataHander: (apiData) => {
            if (apiData) {
              const transformedData = apiData
                .filter((item) => item.is_disabled === 0)
                .map((item, index) => ({
                  orderNo: index + 1,  // Initialize orderNo for display order
                  offerID: item.id,
                  name: item.name,
                }));

              setOfferData(transformedData);
            }
          },
        };

        await sendRequestGetAdvertiserOffers(request);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <div>
      <main className="content">
        <div className="container-fluid p-0">
          <h1>Reorder Advertiser Offers</h1>
          <hr />
          <TableComponent dataSet={offerData} loading={loading} />
        </div>
      </main>
    </div>
  );
}

export default ReorderAdvertiserOffers;
